import React, { Component } from 'react'

export default class IconDoubleCheck extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="7"
                fill="none"
                viewBox="0 0 12 7"
                >
                <g fill="#13A780" clipPath="url(#clip0_1_3)">
                    <path d="M8.234 1.347A.827.827 0 008.443.58C8.385.307 8.21.1 7.985.027c-.237-.074-.492.006-.677.22l-1.442 1.64L3 5.14c-.012-.013-.023-.033-.04-.053l-.637-.754c-.377-.446-.753-.9-1.13-1.353-.15-.18-.312-.273-.492-.28-.272-.02-.532.167-.642.453a.85.85 0 00.156.874L2.455 6.7c.169.2.342.3.528.3h.005c.18 0 .36-.1.527-.293l3.637-4.134c.364-.406.723-.813 1.082-1.226zM11.876.347a.649.649 0 00-.48-.32.685.685 0 00-.557.246l-.764.874c-.868.986-1.737 1.973-2.6 2.96-.214.246-.428.506-.637.76-.08.1-.167.2-.249.306a.174.174 0 01-.029-.04 3.236 3.236 0 00-.127-.153c-.156-.167-.342-.233-.538-.193-.273.046-.458.226-.539.513a.835.835 0 00.15.787c.088.1.169.206.255.306.087.1.174.207.255.307.162.2.336.3.521.3h.012c.18 0 .353-.093.521-.28l4.702-5.347a.861.861 0 00.104-1.026z"></path>
                </g>
                <defs>
                    <clipPath id="clip0_1_3">
                    <path fill="#fff" d="M0 0H12V7H0z"></path>
                    </clipPath>
                </defs>
            </svg>            
        )
    }
}
